import script from "./BuildersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildersSection.vue?vue&type=script&setup=true&lang=js"

import "./BuildersSection.vue?vue&type=style&index=0&id=1e04955c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e04955c"]])

export default __exports__